const pathToPagename = {
  "/login": "Login Page",
  "/register": "Register Page",
  "/forgotPassword": "ForgotPassword Page",
  "/products": "Products Page",
  "/orders": "Orders Page",
  "/reporting": "Reporting Overview Page",
  "/reporting/product/:productId": "Reporting Product Page",
  "/reporting/video/:videoId": "Reporting Video Page"
};

export default pathToPagename;
